import { Box } from "@mui/material";
import { Dispatch, SetStateAction, useEffect } from "react";
import { useTranslation } from "react-i18next";
import type { Swiper as SwiperType } from "swiper";
import { SweeperBullet } from "./SweeperBullet.style";
import { SweeperBulletContainerStyle } from "./SweeperStyles.style";
import { AccessibilityButtonStyle } from "../LucidIcon/LucidIcon.style";


type ISweeperBullet = {
  bullets: Record<string, unknown>[];
  swiperInstance: SwiperType | null;
  activeIndex: number;
  setActiveIndex: Dispatch<SetStateAction<number>>
  idScope?: string;
}

export const SweeperBullets = ({ bullets, swiperInstance, activeIndex, setActiveIndex, idScope }: ISweeperBullet) => {
  const { t } = useTranslation();

  function handleBulletSwipe(index: number) {
    setActiveIndex(index);
    swiperInstance && swiperInstance.slideTo(index, 0.1);
  }

  const isBulletActive = (index: number) => activeIndex === index ? "bullet-active" : "";

  useEffect(() => {
    swiperInstance?.activeIndex && setActiveIndex(swiperInstance?.activeIndex);
  }, [swiperInstance, setActiveIndex]);

  const containerId = idScope ? `slider-pagination-container-${idScope}` : undefined;

  return (
    <Box aria-hidden={ true } tabIndex={ -1 } >
      <SweeperBulletContainerStyle
        role="listitem"
        aria-roledescription={ t("slider_pagination_role_description") }
        aria-label={ t("slider_pagination_aria_label") }
        id={ containerId }
        data-testid="slider-pagination-container"
      >
        { bullets.map((bullet, i) => {
          return (
            <AccessibilityButtonStyle
              aria-hidden={ true } 
              tabIndex={ -1 } 
              key={ i }
              onClick={ () => handleBulletSwipe(i) }
              //aria-label={ `${t("go_to") } ${bullet.title}` }
            >
              <SweeperBullet
                aria-hidden={ true } 
                tabIndex={ -1 } 
                className={ isBulletActive(i) }
              />
            </AccessibilityButtonStyle>
          );
        }) }
      </SweeperBulletContainerStyle>
    </Box>
  );
};
